"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CanvasVideoFrameBuffer_1 = require("./CanvasVideoFrameBuffer");

var DEFAULT_FRAMERATE = 15;
/**
 * [[DefaultVideoFrameProcessorPipeline]] implements {@link VideoFrameProcessorPipeline}.
 * It constructs a buffer {@link CanvasVideoFrameBuffer} as source by default and invokes processor based on `framerate`.
 * The default output type is `MediaStream`.
 */

var DefaultVideoFrameProcessorPipeline = /*#__PURE__*/function () {
  function DefaultVideoFrameProcessorPipeline(logger, stages) {
    var _this = this;

    _classCallCheck(this, DefaultVideoFrameProcessorPipeline);

    this.logger = logger;
    this.stages = stages;
    this.fr = DEFAULT_FRAMERATE; // initialize with dummy inactive MediaStream to keep strict type

    this.outputMediaStream = new MediaStream();
    this.videoInput = document.createElement('video');
    this.canvasOutput = document.createElement('canvas');
    this.outputCtx = this.canvasOutput.getContext('2d');
    this.canvasInput = document.createElement('canvas');
    this.inputCtx = this.canvasInput.getContext('2d');
    this.inputVideoStream = null;
    this.sourceBuffers = [];
    this.destBuffers = [];
    this.observers = new Set();
    this.hasStarted = false;

    this.process = function (_event) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var processVideoStart, buffers, _iterator, _step, proc, imageSource, frameWidth, frameHeight, processVideoLatency, leave, nextFrameDelay;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.inputVideoStream) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                processVideoStart = performance.now(); // videoWidth is intrinsic video width

                if (this.videoInput.videoWidth) {
                  if (this.canvasInput.width !== this.videoInput.videoWidth) {
                    this.canvasInput.width = this.videoInput.videoWidth;
                    this.canvasInput.height = this.videoInput.videoHeight;
                    this.sourceBuffers[0].height = this.canvasInput.height;
                    this.sourceBuffers[0].width = this.canvasInput.width;
                    this.sourceBuffers[0].framerate = this.framerate;
                  }

                  this.inputCtx.drawImage(this.videoInput, 0, 0);
                } // processes input buffers


                buffers = [];
                buffers.push(this.sourceBuffers[0]);
                _context.prev = 6;
                _iterator = _createForOfIteratorHelper(this.processors);
                _context.prev = 8;

                _iterator.s();

              case 10:
                if ((_step = _iterator.n()).done) {
                  _context.next = 17;
                  break;
                }

                proc = _step.value;
                _context.next = 14;
                return proc.process(buffers);

              case 14:
                buffers = _context.sent;

              case 15:
                _context.next = 10;
                break;

              case 17:
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](8);

                _iterator.e(_context.t0);

              case 22:
                _context.prev = 22;

                _iterator.f();

                return _context.finish(22);

              case 25:
                _context.next = 31;
                break;

              case 27:
                _context.prev = 27;
                _context.t1 = _context["catch"](6);
                this.forEachObserver(function (obs) {
                  if (obs.processingDidFailToStart) {
                    obs.processingDidFailToStart();
                  }
                });
                return _context.abrupt("return");

              case 31:
                this.destBuffers = buffers;
                _context.prev = 32;
                _context.next = 35;
                return this.destBuffers[0].asCanvasImageSource();

              case 35:
                imageSource = _context.sent;
                _context.next = 42;
                break;

              case 38:
                _context.prev = 38;
                _context.t2 = _context["catch"](32);

                if (this.inputVideoStream) {
                  this.logger.info('buffers are destroyed and pipeline could not start');
                  this.forEachObserver(function (obs) {
                    if (obs.processingDidFailToStart) {
                      obs.processingDidFailToStart();
                    }
                  });
                }

                return _context.abrupt("return");

              case 42:
                // finally draws the image
                frameWidth = imageSource.width;
                frameHeight = imageSource.height;

                if (frameWidth !== 0 && frameHeight !== 0) {
                  if (this.canvasOutput.width !== frameWidth && this.canvasOutput.height !== frameHeight) {
                    this.canvasOutput.width = frameWidth;
                    this.canvasOutput.height = frameHeight;
                  }

                  this.outputCtx.drawImage(imageSource, 0, 0, frameWidth, frameHeight, 0, 0, frameWidth, frameHeight);

                  if (!this.hasStarted) {
                    this.hasStarted = true;
                    this.forEachObserver(function (observer) {
                      if (observer.processingDidStart) {
                        observer.processingDidStart();
                      }
                    });
                  }
                } // measures time


                processVideoLatency = performance.now() - processVideoStart;
                leave = 1000 * 2 / this.framerate - processVideoLatency; // half fps

                nextFrameDelay = Math.max(0, 1000 / this.framerate - processVideoLatency);

                if (leave <= 0) {
                  this.forEachObserver(function (obs) {
                    if (obs.processingLatencyTooHigh) {
                      obs.processingLatencyTooHigh(processVideoLatency);
                    }
                  });
                } // TODO: use requestAnimationFrame which is more organic and allows browser to conserve resources by its choices.

                /* @ts-ignore */


                this.lastTimeOut = setTimeout(this.process, nextFrameDelay);

              case 50:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 27], [8, 19, 22, 25], [32, 38]]);
      }));
    };
  }

  _createClass(DefaultVideoFrameProcessorPipeline, [{
    key: "destroy",
    value: function destroy() {
      this.stop();

      if (this.stages) {
        var _iterator2 = _createForOfIteratorHelper(this.stages),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var stage = _step2.value;
            stage.destroy();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "framerate",
    get: function get() {
      return this.fr;
    } // A negative framerate will cause `captureStream` to throw `NotSupportedError`.
    // The setter prevents this by switching to the default framerate if less than 0.
    ,
    set: function set(value) {
      this.fr = value < 0 ? DEFAULT_FRAMERATE : value;
    }
  }, {
    key: "stop",
    value: function stop() {
      // empty stream, stop pipeline
      // null input media stream stops the pipeline.
      this.videoInput.removeEventListener('loadedmetadata', this.process);
      this.videoInput.srcObject = null; // Clean the input stream and buffers.

      this.destroyInputMediaStreamAndBuffers(); // Stop all the output tracks, but don't discard the media stream,
      // because it's how other parts of the codebase recognize when
      // a selected stream is part of this transform device.

      if (this.outputMediaStream) {
        var _iterator3 = _createForOfIteratorHelper(this.outputMediaStream.getVideoTracks()),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var track = _step3.value;
            track.stop();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      if (this.lastTimeOut) {
        clearTimeout(this.lastTimeOut);
        this.lastTimeOut = undefined;
      }

      if (this.hasStarted) {
        this.hasStarted = false;
        this.forEachObserver(function (observer) {
          if (observer.processingDidStop) {
            observer.processingDidStop();
          }
        });
      }
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      this.observers.add(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.observers.delete(observer);
    }
  }, {
    key: "getInputMediaStream",
    value: function getInputMediaStream() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.inputVideoStream);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getActiveOutputMediaStream",
    value: function getActiveOutputMediaStream() {
      if (this.outputMediaStream && this.outputMediaStream.active) {
        return this.outputMediaStream;
      }

      return this.outputMediaStream = this.canvasOutput.captureStream(this.framerate);
    }
    /**
     * `inputMediaStream` is by default used to construct one {@link CanvasVideoFrameBuffer}
     * The buffer will be fed into the first {@link VideoFrameProcessor}.
     */

  }, {
    key: "setInputMediaStream",
    value: function setInputMediaStream(inputMediaStream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var settings, canvasBuffer;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (inputMediaStream) {
                  _context3.next = 3;
                  break;
                }

                this.stop();
                return _context3.abrupt("return");

              case 3:
                if (!(inputMediaStream.getVideoTracks().length === 0)) {
                  _context3.next = 6;
                  break;
                }

                this.logger.error('No video tracks in input media stream, ignoring');
                return _context3.abrupt("return");

              case 6:
                this.inputVideoStream = inputMediaStream;
                settings = this.inputVideoStream.getVideoTracks()[0].getSettings();
                this.logger.info("processing pipeline input stream settings ".concat(JSON.stringify(settings)));
                this.canvasOutput.width = settings.width;
                this.canvasOutput.height = settings.height;
                this.videoInput.addEventListener('loadedmetadata', this.process);
                this.videoInput.srcObject = this.inputVideoStream; // avoid iOS safari full screen video

                this.videoInput.setAttribute('playsinline', 'true'); // create sources

                canvasBuffer = new CanvasVideoFrameBuffer_1.default(this.canvasInput);
                this.sourceBuffers.push(canvasBuffer);
                this.videoInput.load();
                _context3.prev = 17;
                _context3.next = 20;
                return this.videoInput.play();

              case 20:
                _context3.next = 25;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](17);
                this.logger.warn('Video element play() overrided by another load().');

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[17, 22]]);
      }));
    }
  }, {
    key: "processors",
    get: function get() {
      return this.stages;
    },
    set: function set(stages) {
      this.stages = stages;
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(observerFunc) {
      var _iterator4 = _createForOfIteratorHelper(this.observers),
          _step4;

      try {
        var _loop = function _loop() {
          var observer = _step4.value;
          setTimeout(function () {
            observerFunc(observer);
          }, 0);
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "destroyInputMediaStreamAndBuffers",
    value: function destroyInputMediaStreamAndBuffers() {
      if (this.inputVideoStream) {
        var _iterator5 = _createForOfIteratorHelper(this.inputVideoStream.getTracks()),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var track = _step5.value;
            track.stop();
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      this.inputVideoStream = null;

      var _iterator6 = _createForOfIteratorHelper(this.sourceBuffers),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var buffer = _step6.value;
          buffer.destroy();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      this.sourceBuffers = [];
    }
  }]);

  return DefaultVideoFrameProcessorPipeline;
}();

exports.default = DefaultVideoFrameProcessorPipeline;